










































































import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import { AnagraficaRequest } from '../models/anagrafica.model';
import { Specializzazione, SpecializzazioneVoce, SpecializzazioneAttivita } from '../models/specializzazione.model';
import { AnagraficaService } from '../services/anagrafica.service';
import { SpecializzazioneService } from '../services/specializzazione.service';
import { Page } from '../models/page.model';

@Component({})
export default class AnagraficaSearch extends Vue {

	@Inject('SpecializzazioneService')
	specializzazioneService!: SpecializzazioneService;
	@Inject('AnagraficaService')
	anagraficaService!: AnagraficaService;

	searchparam: AnagraficaRequest;

	specs: Specializzazione[] = [];
	specsII: SpecializzazioneVoce[] = [];
	specsIII: SpecializzazioneAttivita[] = [];

	constructor() {
		super();
		this.searchparam = new AnagraficaRequest();
	}

	get config() {
		return JSON.parse(process.env.VUE_APP_SEARCH);
	}

	beforeMount() {
		this.specializzazioneService.getAll().then((result) => {
			this.specs = result;
		})
	}

	onSpec1Change() {
		this.searchparam.spec2 = '';
		this.searchparam.spec3 = '';
		if (!this.searchparam.spec1) return []
		const spec = this.specs.filter(s => s.nomespecializzazione === this.searchparam.spec1);
		this.specsII = spec ? spec[0].specII : [];
	}

	onSpec2Change() {
		this.searchparam.spec3 = '';
		if (!this.searchparam.spec2) return []
		const spec = this.specsII.filter(s => s.nome === this.searchparam.spec2);
		this.specsIII = spec ? spec[0].specIII : [];
	}

	search() {
		this.$emit('search', this.searchparam)
	}

	reset() {
		this.searchparam = new AnagraficaRequest();
	}

}
